var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.routes), function(item) {
    return [(!item.hidden && item.noDropdown && item.children.length > 0) ? _c('router-link', {
      attrs: {
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.children[0].name) + "\n        ")], 1)], 1) : _vm._e(), _vm._v(" "), (!item.noDropdown && !item.hidden) ? _c('el-submenu', {
      attrs: {
        "index": item.name
      }
    }, [_c('template', {
      slot: "title"
    }, [((item.name === '商品配送' || item.name === '商品购物') && _vm.waitOrder && _vm.waitOrder.total) ? _c('el-badge', {
      staticClass: "item",
      staticStyle: {
        "margin-right": "20px"
      },
      attrs: {
        "value": "new"
      }
    }) : _vm._e(), _vm._v(" "), (item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.name) + "\n        "), (!!_vm.examineRemind) ? _c('el-badge', {
      attrs: {
        "value": _vm.examineRemind,
        "is-dot": "",
        "hidden": item.name !== '门店管理'
      }
    }) : _vm._e()], 1), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [(!!_vm.examineRemind) ? _c('el-badge', {
        attrs: {
          "is-dot": "",
          "hidden": child.name !== '内容审核'
        }
      }) : _vm._e(), _vm._v("\n            " + _vm._s(child.name) + "\n            "), (child.name === '等待配送' && _vm.waitOrder && _vm.waitOrder.total > 0) ? _c('el-badge', {
        staticClass: "item",
        staticStyle: {
          "margin-right": "10px"
        },
        attrs: {
          "max": 99,
          "value": _vm.waitOrder && _vm.waitOrder.total
        }
      }) : _vm._e()], 1)], 1)] : _vm._e()
    })], 2) : _vm._e()]
  })], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ce21a81e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce21a81e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/SidebarItem.vue
// module id = qghf
// module chunks = 212